import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gf_cart")) || { store: null, items: [] }; }
    catch { return { store: null, items: [] }; }
  });

  useEffect(() => { localStorage.setItem("gf_cart", JSON.stringify(cart)); }, [cart]);

  const addItem = (store, item) => {
    setCart((c) => {
      const sameStore = c.store && c.store.id === store.id;
      const items = sameStore ? [...c.items] : [];
      const idx = items.findIndex((i) => i.id === item.id);
      if (idx >= 0) items[idx] = { ...items[idx], qty: items[idx].qty + 1 };
      else items.push({ ...item, qty: 1 });
      return { store: { id: store.id, name: store.name, delivery_fee: store.delivery_fee, delivery_time: store.delivery_time }, items };
    });
  };

  const setQty = (itemId, qty) =>
    setCart((c) => {
      const items = c.items.map((i) => (i.id === itemId ? { ...i, qty } : i)).filter((i) => i.qty > 0);
      return items.length ? { ...c, items } : { store: null, items: [] };
    });

  const clear = () => setCart({ store: null, items: [] });

  const count = cart.items.reduce((a, i) => a + i.qty, 0);
  const subtotal = cart.items.reduce((a, i) => a + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ cart, addItem, setQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
